import {
  MemoizedSelector,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import {
  State,
  asymmetryVariableRangesesFeatureKey,
  selectAllAsymmetryVariableRangesAdapter,
} from '../reducers/asymmetry-variable-ranges.reducer';
import { AsymmetryVariableRanges } from '@sleipai/sleip-models';

export const selectAsymmetryVariableRangeStoreState =
  createFeatureSelector<State>(asymmetryVariableRangesesFeatureKey);

export const isLoaded = (state: State): boolean => state.loaded;
export const isLoading = (state: State): boolean => state.loading;
export const analysisResultsTextError = (state: State): string | null =>
  state.error;

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectAsymmetryVariableRangeStoreState, isLoading);

export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectAsymmetryVariableRangeStoreState,
  isLoaded
);

export const selectAsymmetryVariableRangeError: MemoizedSelector<
  object,
  string | null
> = createSelector(
  selectAsymmetryVariableRangeStoreState,
  analysisResultsTextError
);

export const selectAllAsymmetryVariableRange = createSelector(
  selectAsymmetryVariableRangeStoreState,
  selectAllAsymmetryVariableRangesAdapter
);

export const selectSingleAsymmetryVariableRange = (id: string) =>
  createSelector(
    selectAllAsymmetryVariableRange,
    (asymmetryVariableRange: AsymmetryVariableRanges[]) => {
      if (asymmetryVariableRange) {
        return asymmetryVariableRange.find(
          (analysisResultsText) => analysisResultsText.id === id
        );
      } else {
        return null;
      }
    }
  );
